export const survey_3cs_permission= {
    required_permission:['view_survey','view_response','add_response','view_answer'],
}